<template>
  <AdminLayout>
    <div class="mt-8 max-w-3xl mx-auto grid grid-cols-1 gap-6 lg:max-w-7xl lg:grid-flow-col-dense lg:grid-cols-3">
      <div class="lg:col-start-1 lg:col-span-2">
        <Card>
          <CardHeader>
            <CardTitle>
              {{ team.company }}
            </CardTitle>
            <CardAction>
              <RadialProgress style="--size: 2rem; font-size: 0.5rem" :progress="team.setup_progress" />
            </CardAction>
          </CardHeader>
          <CardContent>
            <dl class="grid grid-cols-1 gap-x-4 gap-y-8 sm:grid-cols-2">
              <div class="sm:col-span-1">
                <dt class="text-sm leading-5 font-medium text-gray-500">Company</dt>
                <dd class="mt-1 text-sm leading-5 text-gray-900">
                  {{ team.company }}
                </dd>
              </div>
              <div class="sm:col-span-1">
                <dt class="text-sm leading-5 font-medium text-gray-500">Syndication Status</dt>
                <dd class="mt-1 text-sm leading-5 text-gray-900">
                  <Badge :variant="badgeData(team.status).variant">
                    {{ team.status }}
                  </Badge>
                </dd>
              </div>
              <div class="sm:col-span-1">
                <dt class="text-sm leading-5 font-medium text-gray-500">Email Reply To</dt>
                <dd class="mt-1 text-sm leading-5 text-gray-900">
                  <a class="text-indigo-600 hover:text-indigo-900" :href="`mailto:${team.email_reply_to}`">{{
                    team.email_reply_to
                  }}</a>
                </dd>
              </div>
              <div class="sm:col-span-1">
                <dt class="text-sm leading-5 font-medium text-gray-500">Stripe Customer Link</dt>
                <dd class="mt-1 text-sm leading-5 text-gray-900">
                  <a
                    :href="`https://dashboard.stripe.com/customers/${team.stripe_customer_id}`"
                    class="text-indigo-600 hover:text-indigo-900"
                    target="_blank"
                  >
                    Go to Stripe
                  </a>
                </dd>
              </div>
              <div class="sm:col-span-1">
                <dt class="text-sm leading-5 font-medium text-gray-500">Telco Status</dt>
                <dd class="mt-1 text-sm leading-5 text-gray-900">
                  <Badge :variant="badgeData(telco.status).variant">
                    {{ badgeData(telco.status).text }}
                  </Badge>
                </dd>
              </div>
              <div class="sm:col-span-1">
                <dt class="text-sm leading-5 font-medium text-gray-500">Assigned Phone Number</dt>
                <dd class="mt-1 text-sm leading-5 text-gray-900">
                  {{ telco.telnyx_phone_number }}
                </dd>
              </div>
              <div class="sm:col-span-1">
                <dt class="text-sm leading-5 font-medium text-gray-500">Bulk Messaging</dt>
                <dd class="mt-1 text-sm leading-5 text-gray-900">
                  <Badge :variant="badgeData(team.bulk_messaging_enabled).variant">
                    {{ badgeData(team.bulk_messaging_enabled).text }}
                  </Badge>
                </dd>
              </div>
            </dl>
          </CardContent>
        </Card>
        <Card>
          <CardContent>
            <dl class="grid grid-cols-1 gap-x-4 gap-y-8 sm:grid-cols-2">
              <div class="sm:col-span-1">
                <dt class="text-sm leading-5 font-medium text-gray-500">$ Spent</dt>
                <dd class="mt-1 text-sm leading-5 text-gray-900">
                  {{ team.stripe_total_spend }}
                </dd>
              </div>
              <div class="sm:col-span-1">
                <dt class="text-sm leading-5 font-medium text-gray-500">$ MRR</dt>
                <dd class="mt-1 text-sm leading-5 text-gray-900">
                  {{ team.stripe_total_mrr }}
                </dd>
              </div>
              <div class="sm:col-span-1">
                <dt class="text-sm leading-5 font-medium text-gray-500"># of Candidates All Time</dt>
                <dd class="mt-1 text-sm leading-5 text-gray-900">
                  {{ team.number_of_candidates_all_time }}
                </dd>
              </div>
              <div class="sm:col-span-1">
                <dt class="text-sm leading-5 font-medium text-gray-500">
                  # of Unlicensed with Coursework Started Candidates All Time
                </dt>
                <dd class="mt-1 text-sm leading-5 text-gray-900">
                  {{ team.number_of_coursework_started_candidates_all_time }}
                </dd>
              </div>
              <div class="sm:col-span-1">
                <dt class="text-sm leading-5 font-medium text-gray-500"># of Unlicensed Candidates All Time</dt>
                <dd class="mt-1 text-sm leading-5 text-gray-900">
                  {{ team.number_of_unlicensed_candidates_all_time }}
                </dd>
              </div>
              <div class="sm:col-span-1">
                <dt class="text-sm leading-5 font-medium text-gray-500"># of Agents</dt>
                <dd class="mt-1 text-sm leading-5 text-gray-900">
                  {{ team.number_of_agents }}
                </dd>
              </div>
              <div class="sm:col-span-1">
                <dt class="text-sm leading-5 font-medium text-gray-500"># of Candidates Last 30 Days</dt>
                <dd class="mt-1 text-sm leading-5 text-gray-900">
                  {{ team.number_of_candidates_last_30_days }}
                </dd>
              </div>
              <div class="sm:col-span-1">
                <dt class="text-sm leading-5 font-medium text-gray-500"># of Candidates Last 90 Days</dt>
                <dd class="mt-1 text-sm leading-5 text-gray-900">
                  {{ team.number_of_candidates_last_90_days }}
                </dd>
              </div>
              <div class="sm:col-span-1">
                <dt class="text-sm leading-5 font-medium text-gray-500"># of Pipeline Reviews Last 30 Days</dt>
                <dd class="mt-1 text-sm leading-5 text-gray-900">
                  {{ team.number_of_pipeline_reviews_last_30_days }}
                </dd>
              </div>
            </dl>
          </CardContent>
        </Card>
        <FacebookAdvertisingConfigCard
          :config="facebookIntegration"
          :team-id="String(route.params.id)"
          @saved="getTeam()"
        />
        <SmsAdapterConfigCard :config="telco" :team-id="String(route.params.id)" @saved="getTeam()" />
      </div>

      <div>
        <Card>
          <CardHeader>
            <CardTitle> Actions </CardTitle>
          </CardHeader>
          <CardContent>
            <ToggleInput
              label="Active Customer"
              :model-value="team.active_customer"
              @update:model-value="value => updateTeam('active_customer', value)"
            />
            <ToggleInput
              class="mt-4"
              label="Job Syndication"
              :model-value="team.syndication_status"
              @update:model-value="value => updateTeam('status', value)"
            />
          </CardContent>
        </Card>
        <Card>
          <CardHeader>
            <CardTitle> Feature Flags </CardTitle>
          </CardHeader>
          <CardContent>
            <ToggleInput
              label="Force Disable Kickstart"
              :model-value="manageableFeatureFlags.force_disable_kickstart"
              @update:model-value="value => updateTeamFeatureFlag('force_disable_kickstart', value)"
            />
          </CardContent>
        </Card>
        <Card>
          <CardHeader>
            <CardTitle> Integrations </CardTitle>
          </CardHeader>
          <CardContent>
            <dl class="grid grid-cols-1 gap-x-4 gap-y-8">
              <div v-for="integration of dtIntegrations" :key="integration.key" class="sm:col-span-1">
                <dt class="text-sm leading-5 font-medium text-gray-500">{{ integration.label }}</dt>
                <dd class="mt-1 text-sm leading-5 text-gray-900">
                  <Badge v-for="badge of integration.badges" :key="badge" :variant="integration.variant">
                    {{ badge }}
                  </Badge>
                  <p v-if="integration.error" class="mt-1 text-xs text-red-600 break-words">
                    {{ integration.error }}
                  </p>
                </dd>
              </div>
            </dl>

            <Separator class="my-6" />

            <div class="space-y-2">
              <Label class="text-xs font-medium uppercase tracking-[0.08em] text-gray-500">
                ZipRecruiter Tracking Pixel
              </Label>
              <div class="flex items-center gap-2">
                <Input v-model="trackingPixelValue" class="flex-1" placeholder="Conversion tracking ID" />
                <Transition name="fade">
                  <Button
                    v-if="isTrackingPixelDirty"
                    variant="default"
                    size="sm"
                    :disabled="isSavingTrackingPixel"
                    @click="saveTrackingPixel"
                  >
                    {{ isSavingTrackingPixel ? 'Saving...' : 'Save' }}
                  </Button>
                </Transition>
              </div>
            </div>
          </CardContent>
        </Card>
      </div>
    </div>

    <Card class="overflow-hidden">
      <CardHeader>
        <CardTitle id="users-title"> Users </CardTitle>
      </CardHeader>
      <DataTable :columns="dtColumns" :rows="rows" :sort="userSort">
        <template #td-status="slotProps">
          <Badge v-if="slotProps.row" :variant="badgeData(slotProps.row.status).variant">
            {{ slotProps.row.status }}
          </Badge>
        </template>
        <template #td-action="slotProps">
          <div class="flex gap-2">
            <Button
              v-if="slotProps.row.status === 'active'"
              variant="outline"
              size="sm"
              @click="impersonateUser(slotProps.row)"
            >
              Impersonate
            </Button>
            <Button
              v-if="slotProps.row.status === 'active'"
              variant="outline"
              size="sm"
              @click="scheduleCheckin(slotProps.row)"
            >
              Schedule Check-in
            </Button>
          </div>
        </template>
      </DataTable>
    </Card>

    <TeamAdvertisingHistory class="mt-6" :history="budgetHistory" />
  </AdminLayout>
</template>

<script setup lang="ts">
import { ref, computed, onMounted } from 'vue';
import { useRoute } from 'vue-router';
import AdminLayout from '@/components/layouts/AdminLayout/index.vue';
import { Card, CardAction, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Separator } from '@/components/ui/separator';
import DataTable from '../shared/DataTable/DeprecatedDataTable.vue';
import { formatCurrencyToHuman, formatStandardDateTime } from '../../utilities/format.ts';
import RadialProgress from '../shared/RadialProgress.vue';
import ToggleInput from '../shared/ToggleInput.vue';
import TeamAdvertisingHistory from './TeamAdvertisingHistory.vue';
import FacebookAdvertisingConfigCard from './FacebookAdvertisingConfigCard.vue';
import SmsAdapterConfigCard from './SmsAdapterConfigCard.vue';
import { useLoadingSpinnerStore } from '@/stores/loadingSpinner.ts';
import { hFetch } from '@/lib/hfetch';
import { toast } from 'vue-sonner';

/* eslint-disable @typescript-eslint/no-explicit-any */

const route = useRoute();
const loadingSpinnerStore = useLoadingSpinnerStore();

const team = ref<any>({});
const teamMembers = ref<any[]>([]);
const budgetHistory = ref<any[]>([]);
const facebookIntegration = ref<any>(null);
const telco = ref<any>({});
const manageableFeatureFlags = ref<any>({});
const trackingPixelValue = ref('');
const trackingPixelInitial = ref('');
const isSavingTrackingPixel = ref(false);

const isTrackingPixelDirty = computed(() => trackingPixelValue.value !== trackingPixelInitial.value);

const dtIntegrations = computed(() => {
  const defaultData = badgeData(team.value.syndication_status);
  const meta = facebookIntegration.value;
  const metaData = meta ? badgeData(meta.status) : { variant: 'red' as const, text: 'inactive' };

  return [
    { label: 'Indeed', key: 'indeed', variant: defaultData.variant, badges: [defaultData.text] },
    { label: 'ZipRecruiter', key: 'zip', variant: defaultData.variant, badges: [defaultData.text] },
    { label: 'Monster', key: 'monster', variant: defaultData.variant, badges: [defaultData.text] },
    {
      label: 'Meta',
      key: 'meta',
      variant: metaData.variant,
      badges: [meta ? meta.status : metaData.text, meta?.status === 'active' ? meta.form_id : null].filter(
        (e): e is string => !!e
      ),
      error: meta?.status !== 'active' ? meta?.error : null,
    },
  ];
});

const dtColumns = computed(() => [
  { label: 'Mobile Phone Number', key: 'mobile_phone_number', sortable: false },
  { label: 'Email', key: 'email', sortable: false },
  { label: 'Status', key: 'status', sortable: false },
  { label: 'Created', key: 'created_at', formatter: formatStandardDateTime, sortable: false },
  { label: 'Action', key: 'action', sortable: false },
]);

const rows = computed(() => teamMembers.value);

const userSort = computed(() => ({ key: 'created_at', order: 'desc' }));

function badgeData(value: unknown) {
  const isActive = value === true || value === 'active' || value === 'Active';
  return isActive ? { variant: 'green' as const, text: 'active' } : { variant: 'red' as const, text: 'inactive' };
}

async function getTeam() {
  loadingSpinnerStore.showLoadingSpinner();
  const response = await fetch(`/api/admin/teams/${route.params.id}`);
  const data = await response.json();
  loadingSpinnerStore.hideLoadingSpinner();

  data.record.syndication_status = data.record.status === 'Active';
  team.value = data.record;
  team.value.stripe_total_spend = formatCurrencyToHuman(team.value.stripe_total_spend / 100, 0);
  team.value.stripe_total_mrr = formatCurrencyToHuman(team.value.stripe_total_mrr / 100, 0);
  teamMembers.value = data.users;
  telco.value = data.telco;
  facebookIntegration.value = data.facebook_advertising_configuration;
  trackingPixelValue.value = data.record.zip_recruiter_conversion_tracking_id || '';
  trackingPixelInitial.value = trackingPixelValue.value;
}

async function getAdvertising() {
  loadingSpinnerStore.showLoadingSpinner();
  const response = await fetch(`/api/admin/monthly_marketing_budgets?id=${route.params.id}`);
  const data = await response.json();
  loadingSpinnerStore.hideLoadingSpinner();

  for (const budget of data.records) {
    budgetHistory.value.push({
      start_date: budget.start_date,
      end_date: budget.end_date,
      indeed_spend: budget.indeed_spend,
      zip_spend: budget.zip_spend,
      monster_spend: budget.monster_spend,
      meta_spend: budget.meta_spend,
      total_spend: budget.indeed_spend + budget.zip_spend + budget.monster_spend + budget.meta_spend,
      cost_per_candidate: budget.cost_per_candidate,
      number_of_candidates: budget.number_of_candidates,
      cost_per_candidate_indeed: budget.cost_per_candidate_indeed,
      number_of_candidates_indeed: budget.number_of_candidates_indeed,
      cost_per_candidate_zip: budget.cost_per_candidate_zip,
      number_of_candidates_zip: budget.number_of_candidates_zip,
      cost_per_candidate_monster: budget.cost_per_candidate_monster,
      number_of_candidates_monster: budget.number_of_candidates_monster,
      cost_per_candidate_meta: budget.cost_per_candidate_meta,
      number_of_candidates_meta: budget.number_of_candidates_meta,
    });
  }
}

async function getManageableFeatureFlags() {
  const response = await fetch(`/api/admin/teams/${route.params.id}/team_feature_flags`);
  const data = await response.json();
  manageableFeatureFlags.value = data.feature_flags;
}

async function updateTeamFeatureFlag(flag: string, value: boolean) {
  const response = await fetch(`/api/admin/teams/${route.params.id}/team_feature_flags/${flag}`, {
    method: 'PUT',
    body: JSON.stringify({ value }),
    headers: {
      'Content-Type': 'application/json',
      'X-CSRF-TOKEN': (document.querySelectorAll('[name="csrf-token"]')[0] as HTMLMetaElement).content,
    },
  });
  const data = await response.json();
  if (data.status === 'success') {
    toast.success('Team Feature Flag Updated', {
      action: { label: 'Dismiss' },
      description: 'The feature flag was successfully updated.  Use the button below to dismiss this alert.',
    });
  } else {
    toast.error('Team Feature Flag Update Error', {
      action: { label: 'Dismiss' },
      description: 'The feature flag was not updated. Contact #engineering for help.',
    });
  }
}

function impersonateUser(record: any) {
  window.location.href = `/api/admin/teams/${record.id}/impersonate_user`;
}

function scheduleCheckin(record: any) {
  window.location.href = `/interview/${team.value.slug}?event_type=humaniz_checkin&humaniz_checkin_user_id=${record.id}&utm_medium=admin_checkin`;
}

async function saveTrackingPixel() {
  if (!isTrackingPixelDirty.value || isSavingTrackingPixel.value) return;
  isSavingTrackingPixel.value = true;
  try {
    const result = await hFetch<unknown, unknown>({
      url: `/api/admin/teams/${route.params.id}`,
      method: 'PUT',
      payload: { zip_recruiter_conversion_tracking_id: trackingPixelValue.value },
    });
    if (result.status === 'success') {
      trackingPixelInitial.value = trackingPixelValue.value;
      toast.success('ZipRecruiter tracking pixel updated');
    } else {
      toast.error('Update failed', { description: result.messages.join(', ') });
    }
  } catch {
    toast.error('An error occurred while saving');
  } finally {
    isSavingTrackingPixel.value = false;
  }
}

async function updateTeam(field: string, value: boolean) {
  const body = field === 'status' ? { status: value ? 'Active' : 'Inactive' } : { active_customer: value };
  loadingSpinnerStore.showLocalLoadingSpinner();
  const response = await fetch(`/api/admin/teams/${route.params.id}`, {
    method: 'PUT',
    body: JSON.stringify(body),
    headers: {
      'Content-Type': 'application/json',
      'X-CSRF-TOKEN': (document.querySelectorAll('[name="csrf-token"]')[0] as HTMLMetaElement).content,
    },
  });
  const data = await response.json();
  loadingSpinnerStore.hideLocalLoadingSpinner();
  if (data.status !== 'error') {
    toast.success('Customer updated', {
      action: { label: 'Dismiss' },
      description: 'Your customer was successfully updated.  Use the button below to dismiss this alert.',
    });
    await getTeam();
  } else {
    toast.error('Customer update edit error', {
      action: { label: 'Dismiss' },
      description: data.message,
    });
  }
}

onMounted(() => {
  getTeam();
  getAdvertising();
  getManageableFeatureFlags();
});
</script>

<style scoped>
@reference "tailwindcss";

.fade-enter-active,
.fade-leave-active {
  transition: opacity 150ms ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>
